"use client";

import { useEffect, useRef } from "react";

// Self-contained skip button. Uses a useRef + useEffect to attach a NATIVE
// addEventListener directly on the DOM node. React's synthetic onClick was
// failing on browser-back (router cache restore leaves React's event
// delegation in a stale state), but vanilla addEventListener works because
// it's attached straight to the element.
export default function CinSkipButton() {
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const btn = btnRef.current;
    if (!btn) return;

    const onClick = (e: MouseEvent) => {
      e.stopPropagation();
      const live = document.getElementById("cin-intro");
      if (!live || live.classList.contains("done")) return;
      live.style.animation = "none";
      live.classList.add("out");
      window.setTimeout(() => {
        live.classList.add("done");
        document.body.classList.add("cin-ready");
        document.body.classList.add("cin-lb-thin");
        window.setTimeout(() => document.body.classList.remove("cin-lb-thin"), 4000);
      }, 600);
    };

    btn.addEventListener("click", onClick);
    return () => btn.removeEventListener("click", onClick);
  }, []);

  return (
    <button
      ref={btnRef}
      aria-label="Skip intro animation"
      className="cin-skip-btn"
      id="cinSkipBtn"
      type="button"
    >
      SKIP INTRO →
    </button>
  );
}
